/* eslint-disable react/display-name */
import React, { memo } from  'react';
import styled from 'styled-components';

import { withScreenSize } from '../common/utilities/withScreenSize.jsx';
import { translate } from '../../common/translation/translate';
import { AlertsListHeader } from '../alerts/alertsListHeader';
import { OutdoorSportsKeyIndicatorsType } from '../common/interfaces/types.js';
import { KeyIndicatorItem } from './keyIndicatorItem';
import { SunriseWithArrowIcon } from '../common/icons/sunriseWithArrowIcon';
import { SunsetWithArrowIcon } from '../common/icons/sunsetWithArrowIcon';
import { FeelsLikeIcon } from '../common/icons/feelsLikeIcon';
import { PrecipProbIcon } from '../common/icons/precipProbIcon';
import { uvIcon } from '../common/icons/uvIcon';
import { HumidityIcon } from '../common/icons/humidityIcon';
import { WindIcon } from '../common/icons/windIcon';
import { WetBulbIcon } from '../common/icons/wetBulbIcon';
import { largeMediaQuery, mediumMediaQuery, smallMediaQuery } from '../../common/utilities/sizeHelpers.js';
import { OutdoorSportsLoadingErrorUI } from './fallbackUI/outdoorSportsLoadingErrorUI';
import { KeyIndicatorsLoadingUI } from './fallbackUI/keyIndicatorsLoadingUI';

interface OutdoorSportsKeyIndicatorsProps extends OutdoorSportsKeyIndicatorsType {
    outdoorSportsDataIsFetching?: boolean;
    isApiError: boolean;
}

export const OutdoorSportsKeyIndicators = withScreenSize(memo(({
    outdoorSportsDataIsFetching,
    isApiError,
    sunriseDisplayStr,
    sunsetDisplayStr,
    feelsLikeTemperature,
    precipProbabilityPercent100,
    uvDisplayStr,
    humidityPercent100,
    windDisplayStr,
    wetBulbTemperatureDisplayStr
}: OutdoorSportsKeyIndicatorsProps) => {
    return (
        <Container>
            
            <AlertsListHeader>{`${translate('keyIndicators')}`}</AlertsListHeader>
            { outdoorSportsDataIsFetching && <KeyIndicatorsLoadingUI /> }
            { !outdoorSportsDataIsFetching && !sunriseDisplayStr && isApiError && <OutdoorSportsLoadingErrorUI /> }
            { !outdoorSportsDataIsFetching && sunriseDisplayStr && !isApiError
                && <>
                    <KeyIndicatorItem Icon={SunriseWithArrowIcon} keyString={translate('sunrise')} valueString={sunriseDisplayStr} />
                    <KeyIndicatorItem Icon={SunsetWithArrowIcon} keyString={translate('sunset')} valueString={sunsetDisplayStr} />
                    <KeyIndicatorItem Icon={FeelsLikeIcon} keyString={translate('feelsLike')} valueString={`${feelsLikeTemperature}°`}/>
                    <KeyIndicatorItem Icon={PrecipProbIcon} keyString={translate('precipProb')} valueString={`${precipProbabilityPercent100}%`} />
                    <KeyIndicatorItem Icon={uvIcon} keyString={translate('uv')} valueString={uvDisplayStr} />
                    <KeyIndicatorItem Icon={HumidityIcon} keyString={translate('humidity')} valueString={`${humidityPercent100}%`} />
                    <KeyIndicatorItem Icon={WindIcon} keyString={translate('wind')} valueString={windDisplayStr} />
                    <KeyIndicatorItem Icon={WetBulbIcon} keyString={translate('wetBulb')} valueString={wetBulbTemperatureDisplayStr} showBorderBottom={false}/>
                </>
            }
        </Container>
    );
}));

const Container = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #F9F9F9;
    margin: 10px 0;
    height: 420px;
    width: 100%;

    @media ${largeMediaQuery} {
        width: 60%;
        margin: 0 10px 0 10px;
    }

    @media ${smallMediaQuery} {
        height: 415px;
    }
`;
